<template>
    <div class="select_wrapper">
        <div class="select">
            <p
                v-for="item in list"
                :key="item.key"
                @click="!disabled ? check(item) : ''"
                :class="{'active': activeValue === item.key,'disabled':disabled}"
                :style="{
                    'background': activeValue === item.key ? item.color:'',
                    'box-shadow': activeValue === item.key ? item.boxShadow : '',
                    fontSize,
                }"
            >{{item.name}}</p>
        </div>
    </div>
</template>
<script>
/**
 * ComponentName: 两个switch的切换
 * Created Date:2022/4/21
 * Author: shishuo·zhang
 * Modify: zhangjun 样式改版，优化v-model，自适应宽。
 * 组件说明：
 * eg:
 *     <cl-switch :list="list" v-model="activeTab"></cl-switch>
 * list:[{name:'我方',nameEn:'OwnSide',key:'ownSide',color:'#3663E1',boxShadow: '0px 6px 8px rgba(54, 99, 225, 0.3)'}]
 * @change : 点击事件 传出key
 */
export default {
    name: 'cl-switch',
    props: {
        list: { // 切换的tab的列表
            type: Array,
            default: () => []
        },
        value: { // 当前选中的tab
            default: ''
        },
        disabled:{ // 是否禁止用户点击
            type: Boolean,
            default: false
        },
        fontSize: {
            type: String,
            default: '14px'
        },
    },
    data() {
        return {
            activeValue: this.value
        }
    },

    watch: {
        value() {
            this.activeValue = this.value
        }
    },

    methods: {
        check (item) {
            this.activeValue = item.key
            this.$emit('change', item.key)
        }
    },
    model: {
        value: 'value',
        event: 'change'
    },
}
</script>
<style lang="scss" scoped>
.select_wrapper {
    display: inline-block;
    width: auto;
    .select {
        display: flex;
        height: 36px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        justify-content: space-between;
        box-sizing: border-box;
        background: rgba(251, 253, 255, 0.8);
        border: 1px solid #e9edf3;
        border-radius: 4px;
        p {
            display: inline-block;
            width: auto;
            min-width: 73px;
            height: 36px;
            box-sizing: border-box;
            padding: 2px 6px;
            border-radius: 6px;
            cursor: pointer;
            line-height: 32px;
            text-align: center;
            color: #3A3A3A;
            &.active {
                background: #3663E1;
                box-shadow: 0px 6px 8px rgba(54, 99, 225, 0.3);
                border-radius: 6px;
                color: #fff;
            }
            &.disabled{
                cursor:not-allowed;
            }
        }
    }
}
</style>
